import React, { useEffect } from 'react'
import Axios from 'axios'
import {useState} from 'react'
import { useForm } from "react-hook-form";
import MultiSelect from  'react-multiple-select-dropdown-lite'
import  'react-multiple-select-dropdown-lite/dist/index.css'
import BadgeIcon from '@mui/icons-material/Badge';
import LocalPhoneIcon from '@mui/icons-material/LocalPhone';
import EmailIcon from '@mui/icons-material/Email';
import WorkIcon from '@mui/icons-material/Work';
import HolidayVillageIcon from '@mui/icons-material/HolidayVillage';
import LocationCityIcon from '@mui/icons-material/LocationCity';
import CurrencyBitcoinIcon from '@mui/icons-material/CurrencyBitcoin';
import FemaleIcon from '@mui/icons-material/Female';
import MaleIcon from '@mui/icons-material/Male';
import WcIcon from '@mui/icons-material/Wc';
import SellIcon from '@mui/icons-material/Sell';
import CampaignIcon from '@mui/icons-material/Campaign';
import CalendarMonthIcon from '@mui/icons-material/CalendarMonth';
import './CRM2.css'
const Swal = require('sweetalert2');

export const CRMForm2 = () => {
  
  useEffect(() => {
    const token = localStorage.getItem('token')
    fetch('http://27.254.66.164:5000/Author',{
    method: 'POST',
    mode: 'cors',
    headers: {
        'Authorization': 'Bearer '+token,
        'Content-Type': 'application/json',
    },
})
.then(response => response.json())
.then(data => {
        if (data.status === 'ok'){
        } else {
          Swal.fire({
            title: 'กรุณาเข้าสู่ระบบอีกครั้ง',
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#3085d6',
            confirmButtonText: 'ตกลง',
          }).then((result) => {
            if (result.isConfirmed) { 
              window.location.href = '/ec-crm/Login'
            }
          })
        }
    });
})
useEffect(()=> {
  const fetch = async () => {
      try {
          Axios.post('http://27.254.66.164:5000/formserch', {
            CrmCustomerId: CustomerId,
          }).then((response) => {
            setCustomerList(response.data);
          });
      } catch (error) {
          console.error(error)
      }
  }
  fetch()
},[])
async function fetchComments() {
  //Work
  Axios.get('http://27.254.66.164:5000/work').then((response) => {
    setWorkList(response.data);
    
  });
  //income
  Axios.get('http://27.254.66.164:5000/income').then((response) => {
    setIncomeList(response.data);
    
  });
  //location
  Axios.get('http://27.254.66.164:5000/location').then((response) => {
    setLocationList(response.data);
    
  });
  //homeprice
  Axios.get('http://27.254.66.164:5000/homeprice').then((response) => {
    setHomePriceList(response.data);
    
  });
  //promotion
  Axios.get('http://27.254.66.164:5000/promotion').then((response) => {
    setPromotionList(response.data);
    
  });
  //typehome
  Axios.get('http://27.254.66.164:5000/typehome').then((response) => {
    setTypeHomeList(response.data);
    
  });
  //down
  Axios.get('http://27.254.66.164:5000/down').then((response) => {
    setDownList(response.data);
    
  });
  //factor
   Axios.get('http://27.254.66.164:5000/factor').then((response) => {
     setFactorList(response.data);
     
   });
  //chanal
  Axios.get('http://27.254.66.164:5000/chanal').then((response) => {
    setChanalList(response.data);
    
  });
}
useEffect(() => {
  fetchComments();
}, []);

const queryString = window.location.search;
const urlParams = new URLSearchParams(queryString);
const CustomerId = urlParams.get('CustomerId');
 const [Age, setAge] = useState("");
 const [Sex, setSex] = useState("");
 const [Status, setStatus] = useState("");
 const [IncomeId, setIncomeId] = useState("");
 const [TypeHomeId, setTypeHomeId] = useState("");
 const [DownId, setDownId] = useState("");
 const [HomePriceId, setHomePriceId] = useState("");
 const [Suggestion, setSuggestion] = useState("");

 const [WorkId, setWorkId] = useState("");
 const [WorkOther, setWorkOther] = useState("");
 const [LocationId, setLocationId] = useState("");
 const [LocationOther, setLocationOther] = useState("");
 const [PromotionId, setPromotionId] = useState("");
 const [PromotionOther, setPromotionOther] = useState("");
 const [FactorId, setFactorId] = useState("");
 const [FactorOther, setFactorOther] = useState("");
 const [ChanalId, setChanalId] = useState("");
 const [ChanalOther, setChanalOther] = useState("");
  
 const [disabled , setDisabled] = useState(true) 
 const [disabled2 , setDisabled2] = useState(true) 
 const [disabled3 , setDisabled3] = useState(true) 
 const [disabled4 , setDisabled4] = useState(true) 
 const [disabled5 , setDisabled5] = useState(true) 

 const [CustomerList, setCustomerList] = useState([]);
 const [WorkList, setWorkList] = useState([]);
 const [IncomeList, setIncomeList] = useState([]);
 const [LocationList, setLocationList] = useState([]);
 const [TypeHomeList, setTypeHomeList] = useState([]);
 const [HomePriceList, setHomePriceList] = useState([]);
 const [PromotionList, setPromotionList] = useState([]);
 const [DownList, setDownList] = useState([]);
 const [FactorList, setFactorList] = useState([]);
 const [ChanalList, setChanalList] = useState([]);
 const { register, handleSubmit } = useForm({});

 var CryptoJS = require("crypto-js/core");
 CryptoJS.AES = require("crypto-js/aes");
 var secret = "Ec";
 
 //decyptname
 const CusName = CustomerList.map(person => person.CustomerName).toString();
 const decryptCusName = CryptoJS.AES.decrypt(CusName,secret).toString(CryptoJS.enc.Utf8);
 const CustomerName = decryptCusName.substring(1, decryptCusName.length - 1);
 //decyptphone
 const Phone1 = CustomerList.map(person => person.Phone).toString();
 const decryptPhone = CryptoJS.AES.decrypt(Phone1,secret).toString(CryptoJS.enc.Utf8);
 const Phone = decryptPhone.substring(1, decryptPhone.length - 1);
 //decyptEmail
 const Emaill = CustomerList.map(person => person.Email).toString();
 const decryptEmail = CryptoJS.AES.decrypt(Emaill,secret).toString(CryptoJS.enc.Utf8);
 const Email = decryptEmail.substring(1, decryptEmail.length - 1);
 //decyptLine
 const Line = CustomerList.map(person => person.LineID).toString();
 const decryptLine = CryptoJS.AES.decrypt(Line,secret).toString(CryptoJS.enc.Utf8);
 const LineID = decryptLine.substring(1, decryptLine.length - 1);
 useEffect(() => {
  if(WorkId === "1"){
    setDisabled(false)
  }else{
    setDisabled(true) 
  }
}, [WorkId]);
useEffect(() => {
  if(LocationId === "1"){
    setDisabled2(false)
  }else{
    setDisabled2(true) 
  }
}, [LocationId]);
useEffect(() => {
  if(PromotionId === "1"){
    setDisabled3(false)
  }else{
    setDisabled3(true) 
  }
}, [PromotionId]);
 useEffect(() => {
   if(FactorId.includes(99)){
     setDisabled4(false)
   }else{
     setDisabled4(true) 
   }
 }, [FactorId]);
useEffect(() => {
  if(ChanalId === "1"){
    setDisabled5(false)
  }else{
    setDisabled5(true) 
  }
}, [ChanalId]);
const AddCustomer = () => {
      const EmpId = localStorage.getItem('EmpId')
      Axios.post('http://27.254.66.164:5000/addform', {  
        CrmCustomerId: CustomerId, 
        EmpId: EmpId,
        Status: Status,
        Sex: Sex,
        Age: Age,
        WorkId: WorkId,
        WorkOther: WorkOther,
        IncomeId: IncomeId,
        DownId: DownId,
        LocationId: LocationId,
        LocationOther: LocationOther,
        PromotionId: PromotionId,
        PromotionOther: PromotionOther,
        HomePriceId: HomePriceId,
        TypeHomeId: TypeHomeId,
        FactorId: FactorId,
        FactorOther: FactorOther,
        ChanalId: ChanalId,
        ChanalOther: ChanalOther,
        Suggestion: Suggestion
      })
      Swal.fire({
        title: 'สำเร็จ',
        text: "บันทึกสำเร็จ",
        icon: 'success',
        showConfirmButton: false,
        timer: 1500
      }).then((result) => {
            window.location.href = '/ec-crm/';
      })
}
 const  handleOnchange  =  val  => {
   setFactorId(val)
 }
const Values = [
  { label: "", value: 0 }
];
console.log(FactorId)
console.log(FactorId.length)
  return (
    <div className="container">
      <h2 align="center">แบบสอบถามลูกค้า</h2>        
            <form  onSubmit={handleSubmit(AddCustomer)} align="center">   
              <div className="row justify-content-md-center">            
                                  <div className="col col-lg-4" >
                                      <label htmlFor='ProjectId' align="left" className='visually-hidden'>ชื่อ-นามสกุล </label>
                                      <div className="input-group">
                                      <span className="input-group-text"><BadgeIcon /> ชื่อ - นามสกุล</span>
                                      <input type="text" className='form-control' disabled={true}
                                      value={CustomerName}/>
                                      </div>
                                  </div>  
                                  <div className="col col-lg-4">
                                      <label htmlFor='CustomerName' className='visually-hidden'>เบอร์โทรศัพท์</label>
                                      <div className="input-group">
                                      <span className="input-group-text"><LocalPhoneIcon /></span>
                                      <input type="text" className='form-control' disabled={true} 
                                      value={Phone}/>
                                      </div>
                                  </div>
              </div>
              <br></br>
              <div className="row justify-content-md-center">  
                                  <div className="col col-lg-4" >
                                    <label htmlFor='Email' className='visually-hidden'>อีเมล</label>
                                    <div className="input-group">
                                      <span className="input-group-text"><EmailIcon /></span>
                                      <input type="text" disabled={true} className='form-control'
                                      value={Email}  />
                                    </div>
                                  </div>
                                  <div className="col col-lg-4" >
                                    <label htmlFor='LineID' className='visually-hidden'>LineID :</label>
                                    <div className="input-group">
                                       <span className="input-group-text"><img src = {require('./../img/line.png')} width="25" height="25"  alt="logo" /></span>
                                      <input type="text" className='form-control' disabled={true} 
                                      value={LineID} />
                                    </div>
                                  </div>
              </div>
              <br></br>
              <div className="row justify-content-md-center">  
                                  
                                  <div className="col col-lg-4" >
                                  <label htmlFor='Age' className='visually-hidden'>อายุ</label>
                                    <div className="input-group">  
                                        <span className="input-group-text"><img src = {require('./../img/Age.png')} width="25" height="25"  alt="logo" />&nbsp;อายุ</span>
                                        <select className='form-select' {...register("Age",{ required: true })} value={Age} onChange={(e) => {setAge(e.target.value)}}>
                                            <option value="" >กรุณาเลือก</option>
                                            <option value="20-30">20-30 ปี</option>
                                            <option value="31-40">31-40 ปี</option>
                                            <option value="41-50">41-50 ปี</option>
                                            <option value="51+">51 ปีขึ้นไป</option>
                                        </select> 
                                    </div>
                                  </div>
                                  <div className="col col-lg-4" >
                                    <label htmlFor='Status' className='visually-hidden'>สถานภาพ</label>
                                    <div className="input-group">
                                       <span className="input-group-text"><WcIcon /> สถานภาพ</span>
                                       <select className='form-select' value={Status} onChange={(e) => {setStatus(e.target.value)}}>
                                            <option value="" >กรุณาเลือก</option>
                                            <option value="โสด">โสด</option>
                                            <option value="สมรสจดทะเบียน">สมรสจดทะเบียน</option>
                                            <option value="สมรสไม่จดทะเบียน">สมรสไม่จดทะเบียน</option>
                                            <option value="หย่าร้าง">หย่าร้าง</option>
                                        </select> 
                                    </div>
                                  </div>
                                  
                                  
              </div>
              <br></br>
              <div className="row justify-content-md-center">  
                                  <div className="col col-lg-4" >
                                  
                                    <label htmlFor='Sex' className='visually-hidden'>Sex</label>
                                    <div className="input-group">
                                       <span className="input-group-text"><FemaleIcon /><MaleIcon /> เพศ</span>
                                       <select className='form-select' value={Sex} onChange={(e) => {setSex(e.target.value)}}>
                                            <option value="" >กรุณาเลือก</option>
                                            <option value="ชาย">ชาย</option>
                                            <option value="หญิง">หญิง</option>
                                        </select> 
                                    </div>
                                  </div>
                                  <div className="col col-lg-4" >
                                   
                                    <div className="input-group">
                                        <label htmlFor='WorkId' className='visually-hidden'>อาชีพ</label>
                                        <span className="input-group-text"><WorkIcon /> อาชีพ</span>
                                        <select className='form-select' value={WorkId} onChange={(e) => {setWorkId(e.target.value)}}>
                                            <option value="" >กรุณาเลือก</option>
                                            {
                                              WorkList.map( (x,key) => 
                                              <option key={key} value={x.WorkId} >{ x.WorkDes}</option> )
                                            }
                                            <option value="1">อื่นๆ</option>
                                        </select> 
                                      <input type="text" className='form-control'value={WorkOther}  placeholder="อื่นๆ" disabled={disabled} onChange={(e) => {
                                          setWorkOther(e.target.value)
                                        }}/>
                                    </div>
                                  </div>
                                  
                                  
              </div>
              <br></br>
              <div className="row justify-content-md-center">  
                                  <div className="col col-lg-4" >                                
                                    <label htmlFor='Income' className='visually-hidden'>Income</label>
                                    <div className="input-group">
                                       <span className="input-group-text"><CurrencyBitcoinIcon /> รายได้รวมต่อเดือน</span>
                                       <select className='form-select' value={IncomeId} onChange={(e) => {setIncomeId(e.target.value)}}>
                                            <option value="" >กรุณาเลือก</option>
                                            {
                                              IncomeList.map( (x,key) => 
                                              <option key={key} value={x.IncomeId} >{ x.IncomeRange}</option> )
                                            }
                                        </select> 
                                    </div>
                                  </div>
                                  <div className="col col-lg-4" >                                  
                                    <div className="input-group">
                                        <label htmlFor='LocationId' className='visually-hidden'>Location</label>
                                        <span className="input-group-text"><LocationCityIcon /> ทำเลที่สนใจ</span>
                                        <select className='form-select' value={LocationId} onChange={(e) => {setLocationId(e.target.value)}}>
                                            <option value="" >กรุณาเลือก</option>
                                            {
                                              LocationList.map( (x,key) => 
                                              <option key={key} value={x.LocationId} >{ x.LocationDes}</option> )
                                            }
                                            <option value="1">อื่นๆ</option>
                                        </select> 
                                      <input type="text" className='form-control'value={LocationOther}  placeholder="อื่นๆ" disabled={disabled2} onChange={(e) => {
                                          setLocationOther(e.target.value)
                                        }}/>
                                    </div>
                                  </div>                  
              </div>
              <br></br>                         
              <div className="row justify-content-md-center">  
                                  <div className="col col-lg-4" >
                                  
                                    <label htmlFor='TypeHomeId' className='visually-hidden'>TypeHome</label>
                                    <div className="input-group">
                                       <span className="input-group-text"><HolidayVillageIcon />ประเภทบ้านที่สนใจ</span>
                                       <select className='form-select' value={TypeHomeId} onChange={(e) => {setTypeHomeId(e.target.value)}}>
                                            <option value="" >กรุณาเลือก</option>
                                            {
                                              TypeHomeList.map( (x,key) => 
                                              <option key={key} value={x.TypeHomeId} >{ x.TypeHomeDes}</option> )
                                            }
                                        </select> 
                                    </div>
                                  </div>
                                  <div className="col col-lg-4" >
                                   
                                    <div className="input-group">
                                        <label htmlFor='HomePriceId' className='visually-hidden'>HomePriceId</label>
                                        <span className="input-group-text"><SellIcon />ราคาบ้านที่สนใจ</span>
                                        <select className='form-select' value={HomePriceId} onChange={(e) => {setHomePriceId(e.target.value)}}>
                                            <option value="" >กรุณาเลือก</option>
                                            {
                                              HomePriceList.map( (x,key) => 
                                              <option key={key} value={x.HomePriceId} >{ x.HomePriceRange}</option> )
                                            }
                                        </select>
                                    </div>
                                  </div>               
              </div>
              <br></br>                         
              <div className="row justify-content-md-center">  
                                  <div className="col col-lg-4" >                                
                                    <div className="input-group">
                                        <label htmlFor='PromotionId' className='visually-hidden'>PromotionId</label>
                                        <span className="input-group-text"><CampaignIcon /> โปรโมชั่นที่สนใจ</span>
                                        <select className='form-select' value={PromotionId} onChange={(e) => {setPromotionId(e.target.value)}}>
                                            <option value="" >กรุณาเลือก</option>
                                            {
                                              PromotionList.map( (x,key) => 
                                              <option key={key} value={x.PromotionId} >{ x.PromotionDes}</option> )
                                            }
                                            <option value="1">อื่นๆ</option>
                                        </select> 
                                      <input type="text" className='form-control'value={PromotionOther}  placeholder="อื่นๆ" disabled={disabled3} onChange={(e) => {
                                          setPromotionOther(e.target.value)
                                        }}/>
                                    </div>
                                  </div>     
                                  <div className="col col-lg-4" >                               
                                    <label htmlFor='Down' className='visually-hidden'>Down</label>
                                    <div className="input-group">
                                       <span className="input-group-text"><CalendarMonthIcon /> ระยะเวลาผ่อนดาวน์</span>
                                       <select className='form-select' value={DownId} onChange={(e) => {setDownId(e.target.value)}}>
                                            <option value="" >กรุณาเลือก</option>
                                            {
                                              DownList.map( (x,key) => 
                                              <option key={key} value={x.DownId} >{ x.DownDes}</option> )
                                            }
                                        </select> 
                                    </div>
                                  </div>          
              </div>
              <br></br>          
              <div className="row justify-content-md-center">  
                                  <div className="col col-lg-8" >                                
                                    <div className="input-group">
                                        <label htmlFor='FactorId' className='visually-hidden'>FactorId</label>
                                        <span className="input-group-text"><CampaignIcon /> ปัจจัยที่มีผลต่อการซื้อบ้าน</span>
                                        <span className="center"> * โปรดเลือก 3 อันดับที่ท่านคิดว่าสำคัญที่สุด</span>
                                    </div>
                                  </div>            
              </div>
              <div className="row justify-content-md-center">  
                    <div className="col col-lg-8" > 
                        <MultiSelect   
                            className="msl-vars"   
                            value={FactorId}  
                            onChange={handleOnchange} 
                            options={
                                  ( FactorId.length < 6) ?
                                  FactorList.map( (x,i) => 
                                  {return{id: i,value: x.FactorId, label: x.FactorDes };}
                                    ): ""}
                        />
                        <input type="text" className='form-control'value={FactorOther}  placeholder="อื่นๆ" disabled={disabled4} onChange={(e) => {
                            setFactorOther(e.target.value)
                        }}/>                   
                    </div>            
              </div> 
              <br></br>  
              <div className="row justify-content-md-center">     
                                  <div className="col col-lg-8" > 
                                    <div className="input-group">
                                      <label htmlFor='ChanalId' className='visually-hidden'>ChanalId</label>
                                            <span className="input-group-text"><CampaignIcon />ทราบข้อมูลโครงการจากสื่อใด</span>
                                      <select className='form-select' value={ChanalId} onChange={(e) => {setChanalId(e.target.value)}}>
                                                <option value="" >กรุณาเลือก</option>
                                                {
                                                  ChanalList.map( (x,key) => 
                                                  <option key={key} value={x.ChanalId} >{ x.ChanalDes}</option> )
                                                }
                                                <option value="1">อื่นๆ</option>
                                      </select>      
                                      <input type="text" className='form-control'value={ChanalOther}  placeholder="อื่นๆ" disabled={disabled5} onChange={(e) => {
                                          setChanalOther(e.target.value)
                                      }}/>    
                                    </div>
                                  </div>         
              </div>
              <br></br>              
              <div className="row justify-content-md-center">  
                                                <div className="col col-lg-8" >
                                                        <label htmlFor='Suggestion' align="left" className='visually-hidden'>Suggestion</label>
                                                        <div className="input-group">
                                                          <div className="input-group-text">ข้อเสนอแนะ อื่นๆ</div>
                                                          <textarea  className='form-control'  value={Suggestion} onChange={(e) => {
                                                                setSuggestion(e.target.value)}}/>
                                                        </div>
                                                </div>                   
              </div>
                                
                              
              <br></br>
              <button type='submit'className='btn btn-success'>ส่งฟอร์มลูกค้า</button>
            </form>     
    </div>
  );
}

